<app-page-container>
  <div class="header">
    <app-header class="c-header" appTitle="Suprimentos" divider [paddingBottom]="false">
      <p class="is-title">Abrir novo chamado</p>
    </app-header>
  </div>
  <div class="c-router-outlet-container">
    <router-outlet></router-outlet>
  </div>
</app-page-container>